import React from 'react';
import tenda from '~/assets/images/tenda.svg';
import { whiteColor, infoColor } from '~/components/layout/Variables';

import styled from 'styled-components';
import formatCnpj from '@brazilian-utils/format-cnpj';

const HeaderContent = styled.header`
  background-color: ${() => infoColor};
  color: ${() => whiteColor};
  font-size: 0.8rem;
  font-weight: 500;
  text-align: center;
  padding: 0.4rem 1rem;
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    margin-right: 0.7rem;
  }
`;

export default function HeaderMobile() {
  return (
    <>
      <HeaderContent>
        <img src={tenda} alt="" />
        {localStorage.getItem('storeName')} -{' '}
        {formatCnpj(localStorage.getItem('storeDocument'))}
      </HeaderContent>
    </>
  );
}
